import dayjs from "dayjs";
import objectSupport from "dayjs/plugin/objectSupport";

dayjs.extend(objectSupport);

class EntryTimer extends HTMLElement {
  #timestamp = null;
  #startTime = null;
  #timer = null;
  #intervalID = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initTimer();
    this.startTimer();
    this.render();
  }

  disconnectedCallback() {
    clearInterval(this.#intervalID);
  }

  initTimer() {
    if (this.#startTime === dayjs().format()) {
      console.log("null!");
      this.#timer = dayjs({ h: 0, m: 0, s: 0 });
      return;
    }

    const [hours, minutes, secs = 0] = dayjs(this.#startTime)
      .format("HH:mm:ss")
      .split(":")
      .map(Number);

    const [nowHours, nowMinutes, nowSecs] = dayjs()
      .format("HH:mm:ss")
      .split(":")
      .map(Number);

    const h = nowHours - hours;
    const m = nowMinutes - minutes;
    const s = nowSecs - secs;

    this.#timer = dayjs({ hour: h, minute: m, second: s });
  }

  render() {
    const showHours = this.#timer.format("HH") !== "00";
    const timestamp = showHours
      ? this.#timer.format("HH:mm:ss")
      : this.#timer.format("mm:ss");

    this.innerHTML = `<div class='timer'>${timestamp}</div>`;
  }

  startTimer() {
    this.#intervalID = setInterval(() => {
      this.#timer = this.#timer.add({ s: 1 });
      this.render();
    }, 1000);
  }

  set setStartTime(value) {
    this.#startTime = value;
  }
}

customElements.define("entry-timer", EntryTimer);
